import { Link } from '@backstage/core-components';
import { IconComponent } from '@backstage/core-plugin-api';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';

interface CardLinkProps {
  icon: IconComponent;
  text: string;
  url: string;
}

const useStyles = makeStyles(() => ({
  linkText: {
    display: 'inline-flex',
    alignItems: 'center',
  },
}));

export const CardLink = ({ icon: Icon, text, url }: CardLinkProps) => {
  const styles = useStyles();

  return (
    <div className={styles.linkText}>
      <Icon fontSize="small" />
      <Link style={{ marginLeft: '8px' }} to={url}>
        {text || url}
      </Link>
    </div>
  );
};
